export enum DeckingBoardTypeEnum {
  wood = 0,
  composite = 1,
}
